
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "PopUpImages",

  data: function () {
    return {
      swiperOptions: {
        centeredSlides: true,
        maxBackfaceHiddenSlides: 1,
        loop: true,
        keyboard: { enabled: true },

        navigation: {
          prevEl: '.pop-up-images__button-navigation--prev',
          nextEl: '.pop-up-images__button-navigation--next',
        },
      },
    }
  },

  computed: {
    isOpen: function () {
      return this.$store.state["pop-up-images"]?.isOpen || false
    },
    images: function () {
      return this.$store.state["pop-up-images"]?.images || []
    }
  },

  components: {
    Swiper,
    SwiperSlide
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        document.body.style.overflow = "hidden";
        return
      }

      document.body.style = "";
    }
  },

  mounted() {
    this.addEscapeListener();
  },

  beforeDestroy() {
    this.removeEscapeListener();
  },

  methods: {
    onClose: function () {
      this.$store.commit("pop-up-images/closePopUp")
    },

    initSwiper: function () {
      const activeIndex = this.$store.state["pop-up-images"]?.activeIndex;
      if (activeIndex <= 0) {
        return
      }
      this.$refs.refSwiper?.$swiper.slideTo(activeIndex);
    },
    onKeyDown: function (evt) {
      if (evt.keyCode === 27) {
        this.onClose()
      }
    },
    addEscapeListener: function () {
      document.addEventListener('keydown', (event) => this.onKeyDown(event) );
    },
    removeEscapeListener: function () {
      document.removeEventListener('keydown', this.onKeyDown());
    },
  }
}
